import Moment from "react-moment";

const ViewAdminUser = ({ data }) => {
    const { firstName, lastName, email, phone, lastLogin, loginCount, createdAt } = data;

    return (
        <>
            <h5 className="mb-4">View Admin</h5>
            <div className=" info-table">
                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">First Name</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{firstName}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Last Name</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{lastName}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Email</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{email}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Phone</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{phone}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Last Login</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>
                                        {lastLogin && loginCount ? (
                                            <Moment format="MMM DD, YYYY HH:mm">{lastLogin}</Moment>
                                        ) : null}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Total Login</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{loginCount}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="">Create At</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>
                                        {createdAt ? (
                                            <Moment format="MMM DD, YYYY HH:mm">{createdAt}</Moment>
                                        ) : null}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewAdminUser;
